"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var InputInfo = _styledComponents["default"].span.withConfig({
  displayName: "input-info__InputInfo",
  componentId: "sc-1rlakp5-0"
})(["display:block;line-height:1.5em;margin:5px 0 0 0;color:#afafaf;font-size:11px;padding:0 10px;max-width:80%;a{text-decoration:underline;color:inherit;}"]);

var _default = InputInfo;
exports["default"] = _default;